/** nf_messages.sender_type ENUM: jobseeker, recruiter, ADMIN (legacy rows may be uppercase). */

export function isSenderJobseeker(senderType) {
  return String(senderType || "").toLowerCase() === "jobseeker";
}

export function isSenderRecruiter(senderType) {
  return String(senderType || "").toLowerCase() === "recruiter";
}

export function isSenderAdmin(senderType) {
  const s = String(senderType || "");
  return s === "ADMIN" || s.toLowerCase() === "admin";
}
